var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoinIconsCartOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 17.0835C9.02434 17.0835 9.58398 16.5239 9.58398 15.8335C9.58398 15.1431 9.02434 14.5835 8.33398 14.5835C7.64363 14.5835 7.08398 15.1431 7.08398 15.8335C7.08398 16.5239 7.64363 17.0835 8.33398 17.0835Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 17.0835C14.8573 17.0835 15.417 16.5239 15.417 15.8335C15.417 15.1431 14.8573 14.5835 14.167 14.5835C13.4766 14.5835 12.917 15.1431 12.917 15.8335C12.917 16.5239 13.4766 17.0835 14.167 17.0835Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91699 3.3335H4.58366L7.50366 12.5002H14.167",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85333 10.417L5.25 5.41699H15.6725C15.7386 5.41691 15.8037 5.43254 15.8625 5.46258C15.9213 5.49262 15.9722 5.53622 16.0109 5.58978C16.0495 5.64334 16.0749 5.70532 16.0849 5.77062C16.0949 5.83592 16.0892 5.90265 16.0683 5.96533L14.6792 10.132C14.6515 10.2149 14.5985 10.2871 14.5276 10.3382C14.4568 10.3894 14.3716 10.4169 14.2842 10.417H6.85333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinIconsCartOutline);
export default __webpack_public_path__ + "static/media/bitcoin-icons_cart-outline.616a0e6e83050f73a7c5d6db45717bab.svg";
export { ForwardRef as ReactComponent };